import React from "react";
import ContentBox from "../../Box/ContentBox/ContentBox";
import statusIcon from "../../../assets/icons/serviceOverview/IconStatus";
import Status from "../../Status/Status";
import { getStatusBoxConfig } from "../../../services/serviceWorldService";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type StatusBoxProps = {
  product: AbstractCase;
};

const StatusBox = ({ product }: StatusBoxProps) => {
  if (!product) {
    return null;
  }

  const statusConfig = getStatusBoxConfig(product);

  const ExtraContent = () => statusConfig.extraContent || null;

  return (
    <ContentBox icon={statusIcon} headline={"Status"} alignContent={"stretch"}>
      <Status
        ctaButton={statusConfig.ctaButton}
        maxPercentage={statusConfig.percentage}
        nextStepContent={{
          header: statusConfig.header,
          text: statusConfig.text,
        }}
      />
      <ExtraContent />
    </ContentBox>
  );
};

export default StatusBox;
